import type { FunctionComponent } from "react";
import type { IFavoriteSocial } from "../hooks/http/admin/favorites/get-all-favorites.admin.http";
import { Button } from "./ui/button";
import ArrowTopRightIcon from "../assets/svgs/common/arrow-top-right.svg";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";

export const FavoriteCard: FunctionComponent<{ favorite: IFavoriteSocial }> = ({
	favorite,
}) => {
	return (
		<div className="flex flex-col justify-between bg-bginput p-4 border border-border rounded-lg h-80">
			<div className="flex flex-col gap-4 font-semibold">
				<h4 className="text-xl">{favorite.name}</h4>

				<p className="text-secondary text-sm">{favorite.description}</p>
			</div>
			<div className="flex flex-col gap-2 w-full">
				<div className="flex justify-between items-center w-full font-semibold">
					<p className="text-secondary text-xs">
						Created by: {favorite.createdBy.name}
					</p>
					<p className="text-secondary text-xs">
						{DateTime.fromISO(favorite.createdAt.toString())
							.setZone("local")
							.toFormat("dd LLL, hh:mm a")}
					</p>
				</div>

				<Link className="w-full" to={`/admin/favorites/${favorite.id}`}>
					<Button className="bg-tertiarybuttonbg py-6 border border-border w-full font-semibold">
						View group <ArrowTopRightIcon />
					</Button>
				</Link>
			</div>
		</div>
	);
};
